<template>
    <div :class="classList">
        <VExpandTransition>
            <VProgressLinear v-if="hasTimeout" v-show="timeoutPercentage > 0" :color="primaryColor" :value="timeoutPercentage" />
        </VExpandTransition>
        <VExpandTransition>
            <VAlert v-model="show" :color="primaryColor" :text="!outlined" :outlined="outlined" tile>
                <VIcon slot="prepend" :color="primaryColor">
                    {{ icon }}
                </VIcon>

                <div class="pl-4 notification-body">
                    <span class="font-weight-bold d-block notification-title"> {{ title }} </span>
                    <span class="notification-description"> {{ description }} </span>
                    <div slot="default">
                        <slot />
                    </div>
                </div>

                <VIcon v-if="dismissible" slot="append" :class="closeIconClassList" :color="primaryColor" @click="close()">
                    mdi-close-circle
                </VIcon>
            </VAlert>
        </VExpandTransition>
    </div>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-notification-wrapper';

const colorByTypeMap = {
    success: 'green',
    warning: 'orange',
    error: 'red',
    info: 'blue',
};

export default {
    name: 'SrNotification',
    props: {
        type: {
            type: String,
            default: 'success',
            validator(value) {
                return ['success', 'warning', 'error', 'info'].includes(value);
            },
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: '',
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        dismissible: {
            type: Boolean,
            default: false,
        },
        timeout: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            show: true,
            closingTimeout: null,
            timeoutPercentage: 0,
            timeoutPercentageUpdateInterval: null,
        };
    },
    computed: {
        primaryColor() {
            return this.getColorByType(this.type);
        },
        hasTimeout() {
            return this.timeout > 0;
        },
        icon() {
            return this.type === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle';
        },
        classList() {
            return [ELEMENT_CLASS];
        },
        closeIconClassList() {
            return [USER_INPUT_CLASS];
        },
    },
    mounted() {
        if (this.hasTimeout) {
            this.initiateTimeout(this.timeout);
        }
    },
    methods: {
        close() {
            this.show = false;
            this.$emit('close');
        },
        getColorByType(type) {
            return colorByTypeMap[type];
        },
        initiateTimeout(seconds) {
            this.timeoutPercentage = 99;

            this.timeoutPercentageUpdateInterval = setInterval(() => {
                this.timeoutPercentage -= 1;
            }, (seconds * 1000) / 100);

            this.closingTimeout = setTimeout(() => {
                this.close();
            }, seconds * 1000);
        },
    },
};
</script>
